const description = 'Dufferin is a family that grows with the contribution of each employee. We are proud to participate in major projects, because together, we are building a better world.'
const title = 'Dufferin Career'

export const setMeta = seo => {
	document.title = seo.title || title
	const metas = document.getElementsByTagName('meta')
	metas['og:title'].content = seo.title || title
	metas['description'].content = seo.description || description
	metas['og:description'].content = seo.description || description
	metas['og:image'].content = seo.image?.original || 'https://api.emplois.demix.ca/storage/66/conversions/92f78f9b-37fc-482d-ab91-c6816a78d017-1-201-a-optimized.jpeg'
	metas['og:type'].content = seo.type || 'website'
	metas['twitter:card'].content = seo.twitter || seo.description || 'summary'
}
